<template>
  <div
    ref="targetRef"
    v-click-outside="onClickOutside"
    class="header__lang header__lang--decorated"
  >
    <span
      class="header__lang-button"
      @click="setIsVisible(true)"
    >
      {{ savedLocale }}
    </span>
    <ul
      v-if="isVisible"
      class="header__lang-list"
    >
      <li
        class="header__lang-list-item"
        @click="changeLocale('ru')"
      >
        Ru
      </li>
      <li
        class="header__lang-list-item"
        @click="changeLocale('uz')"
      >
        Uz
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useLocalState } from '@/shared/composition';
import { $i18n } from '@/shared/helpers/i18n';
import { useLocalStorage } from '@/shared/composition/useLocalStorage';

export default defineComponent({
  name: 'ChangeLanguage',
  setup() {
    const savedLocale = useLocalStorage('SF_LANG', 'ru');
    const changeLocale = (locale: 'ru' | 'uz') => {
      if ($i18n.locale !== locale) {
        $i18n.locale = locale;
        savedLocale.value = locale;
      }

      setIsVisible(false);
    };

    const [isVisible, setIsVisible] = useLocalState(false);
    const [targetRef] = useLocalState<HTMLElement | null>(null);
    const onClickOutside = () => {
      setIsVisible(false);
    };

    return {
      changeLocale,
      isVisible,
      savedLocale,
      setIsVisible,
      targetRef,
      onClickOutside,
    };
  },
});
</script>
